import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { BordroDurum, OdemeDurum, PersonelDurum } from '../types'

const personelCls: Record<PersonelDurum, string> = {
  aktif: 'bg-success/12 text-success',
  izinli: 'bg-info/12 text-info',
  deneme: 'bg-warning/15 text-warning-strong',
}

const personelDot: Record<PersonelDurum, string> = {
  aktif: 'bg-success',
  izinli: 'bg-info',
  deneme: 'bg-warning',
}

const bordroCls: Record<BordroDurum, string> = {
  onay: 'bg-success/12 text-success',
  kontrol: 'bg-info/12 text-info',
  taslak: 'bg-muted text-muted-foreground',
}

const odemeCls: Record<OdemeDurum, string> = {
  odendi: 'bg-success/12 text-success',
  planlandi: 'bg-info/12 text-info',
  onay_bekliyor: 'bg-warning/15 text-warning-strong',
}

const odemeDot: Record<OdemeDurum, string> = {
  odendi: 'bg-success',
  planlandi: 'bg-info',
  onay_bekliyor: 'bg-warning',
}

export function PersonelStatusPill({ durum }: { durum: PersonelDurum }) {
  const { t } = useTranslation()
  return (
    <span className={cn('inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium', personelCls[durum])}>
      <span className={cn('size-1.5 rounded-full', personelDot[durum])} />
      {t(`hr.personel.durum.${durum}`)}
    </span>
  )
}

export function BordroStatusPill({ durum }: { durum: BordroDurum }) {
  const { t } = useTranslation()
  return (
    <span className={cn('inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium', bordroCls[durum])}>
      {t(`hr.personel.bordro.durum.${durum}`)}
    </span>
  )
}

export function OdemeStatusPill({ durum }: { durum: OdemeDurum }) {
  const { t } = useTranslation()
  return (
    <span className={cn('inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium', odemeCls[durum])}>
      <span className={cn('size-1.5 rounded-full', odemeDot[durum])} />
      {t(`hr.personel.odeme.durum.${durum}`)}
    </span>
  )
}

export function SoftTag({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-transparent bg-secondary px-2.5 py-1 text-xs font-medium text-secondary-foreground',
        className,
      )}
    >
      {children}
    </span>
  )
}
